import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { IColumnModel, ColumnModel } from 'table-editor';

export class State extends StarbaseEntity implements Serializable<State> {
    public state_Name: string;
    public abbreviation: string;
    public editMode: boolean;
  public editable: boolean;

  constructor() {
    super();
  }

    public static StateColumnData(editable: boolean = false): IColumnModel[] {
        return [
            new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
            new ColumnModel('State', 'state_Name', 'state_Name', editable, 'string', true, true, 20, false),
            new ColumnModel('Abbreviation', 'abbreviation', 'abbreviation', editable, 'string', false, true, 100, false),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'createdDateTime', false, 'date', false, true, 50, false),
            new ColumnModel('Created By', 'createdByUser', 'createdByUser', false, 'string', false, true, 20, false)
        ];
    }

    deserialize(input) {
        return Object.assign(new State(), input);
    }
}
